export default "__VITE_ASSET__927cf2b8__"